import { ElementRef, Injectable, NgZone } from "@angular/core";
import { Endpoint } from "../../models/enums";
import { ReportType } from "../../models/report";
import { OperationState, TaskType } from "../../models/task";
import { CommonService } from "../common/common.service";
import { RestService } from "../rest/rest.service";

@Injectable()
export class DownloadService {

    constructor(private commonService: CommonService, private restService: RestService, private ngZone: NgZone) {
    }

    download(task: any, downloadLink: ElementRef): void {
        let endpoint: Endpoint;
        let postParams;
        let downloadFileName = '';

        const hasListOfExceptions = task.operationState === OperationState.WARNING && task.taskType === TaskType.OTHER && task.warnings;
        if (!hasListOfExceptions && ((task.operationState === OperationState.WARNING) ||
            (task.taskType === TaskType.VIEW_MANIFEST_DOWNLOAD) ||
            (task.taskType === TaskType.EXPORT_STREAM_CUSTODIAN_UPDATE_DOWNLOAD) ||
            (task.taskType === TaskType.DOWNLOAD_DOCUMENTS) ||
            (task.taskType === TaskType.COMPARE_EXPORT))) {
            endpoint = Endpoint.viewManager_retrieveManifestURL;
            postParams = { taskHandle: task.handle };

            downloadFileName = task.taskType === TaskType.COMPARE_EXPORT ? 'ExportComparisonReport' :
                task.description.includes('Generating Audit Log') ? 'AuditLog' : 'WorkBasketManifest';

        } else if ((task.task === 'PROJECT_BILLING_REPORT') || (task.task === 'DATA_PROCESSING_REPORT') || (task.task === 'TERM_SEARCH_HIT_COUNT') || (task.task === 'SLACK_DATA_REPORT') || (task.task === 'SOURCE_TRACKING_REPORT') || (task.task === TaskType.GENERATE_CLUSTER_REPORT) ||
            (task.taskType === TaskType.OTHER && (task.warnings || (task.warningDetails && task.warningDetails.url))) || task.task === 'DOMAIN_COMMUNICATION' || task.task === 'EMAIL_COMMUNICATION') {

            endpoint = Endpoint.viewManager_retrieveReport;
            let reportType: string;
            let attributes;
            if (task.task === 'PROJECT_BILLING_REPORT') {
                reportType = ReportType.CONSOLIDATED_BILLING_REPORT;
                attributes = [{ name: 'xlsx', value: 'true' }];
            } else if (task.task === 'DATA_PROCESSING_REPORT') {
                reportType = ReportType.DATA_PROCESSING_REPORT;
                attributes = [{ name: 'xlsx', value: 'true' }];
            } else if (task.task === 'TERM_SEARCH_HIT_COUNT') {
                reportType = ReportType.TERM_SEARCH_HIT_COUNT;
                attributes = [{ name: 'xlsx', value: 'true' }];
            } else if (task.task === 'SOURCE_TRACKING_REPORT') {
                reportType = ReportType.SOURCE_TRACKING_REPORT;
                attributes = [{ name: 'xlsx', value: 'true' }];
            } else if (task.task === TaskType.GENERATE_CLUSTER_REPORT) {
                reportType = ReportType.CLUSTER;
                attributes = [{ name: 'xlsx', value: 'true' }];
            } else if (task.task === 'DOMAIN_COMMUNICATION' || task.task === 'EMAIL_COMMUNICATION') {
                reportType = task.task;
                attributes = [{ name: 'xlsx', value: 'true' }];
                if (task.operationState === OperationState.WARNING) {
                    this.commonService.openInformationToastNotification('Excel column or row cap reached. Download file will contain limited data.');
                }
            } else if (task.task === 'SLACK_DATA_REPORT') {
                reportType = task.task;
                attributes = [{ name: 'xlsx', value: 'true' }];
            } 
            else {
                reportType = 'WARNING_DETAILS_REPORT';
                attributes = [{ name: 'csv', value: 'true' }];
                const exportVolumeName = task.attributes.find(a => a.name === 'exportVolumeName'),
                    exportStreamName = task.attributes.find(a => a.name === 'exportStreamName');
                downloadFileName = exportVolumeName?.value && exportStreamName?.value ? exportStreamName.value + '-' + exportVolumeName.value + '_Native_Text_Errors' : reportType;
            }
            postParams = {
                handle: task.handle,
                reportRequest: { reportType: reportType, attributes: attributes }
            };
        }

        this.restService.post(endpoint, postParams).then(response => {
            if (response) {
                const url = (response.viewManifestUrl && response.viewManifestUrl.length > 0) ? response.viewManifestUrl : response.url;
                if (task.taskType === TaskType.DOWNLOAD_DOCUMENTS) {
                    if (task.operationState === OperationState.WARNING && task.warnings) {
                        this.restService.post(Endpoint.viewManager_retrieveReport, {
                            handle: task.handle,
                            reportRequest: { reportType: 'WARNING_DETAILS_REPORT', attributes: [{ name: 'csv', value: 'true' }] }
                        }).then(response => {
                            if (response) {
                                const url = (response.viewManifestUrl && response.viewManifestUrl.length > 0) ? response.viewManifestUrl : response.url;
                                this.ngZone.runOutsideAngular(() => {
                                    this.commonService.unzipFile(url, downloadLink.nativeElement, 'WARNING_DETAILS_REPORT');
                                });
                            }
                        }, error => {
                            console.error('Failed to download!' + error);
                        });

                    }
                    downloadLink.nativeElement.href = this.commonService.nonRestUrl + '/ediscovery/' + url;
                    downloadLink.nativeElement.click();
                } else {
                    this.ngZone.runOutsideAngular(() => {
                        this.commonService.unzipFile(url, downloadLink.nativeElement, downloadFileName);
                    });
                }
            }
        }, error => {
            console.error('Failed to download!' + error);
        });
    }
}